import { render, staticRenderFns } from "./AnnouncementListener.vue?vue&type=template&id=2585abf6&scoped=true&"
import script from "./AnnouncementListener.vue?vue&type=script&lang=js&"
export * from "./AnnouncementListener.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementListener.vue?vue&type=style&index=0&id=2585abf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585abf6",
  null
  
)

export default component.exports